import { OfferingSelectionOperator } from "@/models"

export interface OfferingSelectionState {
  selections: OfferingSelectionOperator[]
}

export const InitialState: OfferingSelectionState = {
  selections: []
}
